module.exports = __webpack_public_path__ + "static/media/glass-citrus.9049dcac.svg";